"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawLabelLines = void 0;
function drawLabelLines(context, x, y, dotX, dotY, lineOffset, lineColor, theme, LINE_WIDTH, DOT_SIZE) {
    context.beginPath();
    context.moveTo(x, y);
    context.lineTo(x + lineOffset, y);
    context.lineTo(dotX, dotY);
    context.strokeStyle = lineColor;
    context.lineWidth = LINE_WIDTH;
    context.stroke();
    context.beginPath();
    context.moveTo(x, y + 1);
    context.lineTo(x + lineOffset, y + 1);
    context.lineTo(dotX, dotY + 1);
    context.strokeStyle = theme.labels.lineShadow;
    context.lineWidth = LINE_WIDTH;
    context.stroke();
    context.beginPath();
    context.arc(dotX, dotY, DOT_SIZE + 1, 0, 2 * Math.PI, false);
    context.fillStyle = theme.labels.lineShadow;
    context.fill();
    context.beginPath();
    context.arc(dotX, dotY, DOT_SIZE, 0, 2 * Math.PI, false);
    context.fillStyle = lineColor;
    context.fill();
}
exports.drawLabelLines = drawLabelLines;
